import Button from "@lhd/components/Button";
import { IPermissionItem } from "@lhd/types";
import { FormInstance } from "antd";

export interface ButtonToCancelProps {
  form: FormInstance;
  isEditing?: boolean;
  permission?: IPermissionItem;
  isUploading?: boolean;
  hasChanged: boolean;
  setHasChanged: (v: boolean) => void;
  dataVersion: number;
  initialValues: Record<string, any>;
}

const ButtonToCancel = ({
  form,
  isEditing,
  permission,
  isUploading,
  hasChanged,
  setHasChanged,
  dataVersion,
  initialValues,
}: ButtonToCancelProps) => {
  const handleCancel = () => {
    form.setFieldsValue(initialValues);
    setHasChanged(false);
  };

  return (
    <Button
      disabled={!isEditing || !permission?.edit || !hasChanged || !!isUploading}
      label="キャンセル"
      onClick={handleCancel}
      className="btn btn-cancel"
    />
  );
};

export default ButtonToCancel;
